import '@/styles/globals.scss'
import '@/styles/flexboxgrid.scss'
import type { AppProps } from 'next/app'
import React, { FC, useEffect } from 'react'
import { Provider } from 'react-redux'
import { wrapper } from '../store/store'
import { appWithTranslation } from 'next-i18next'
import { Exo } from "next/font/google"
import SnackbarManager from '@/features/snackbar/SnackbarManager/SnackbarManager'
import NextNProgress from 'nextjs-progressbar'
import SessionManager from '@/components/common/SessionManager/SessionManager'
import { pageView } from '@/lib/gtm'
import { usePrevious } from '@/utils/hooks/usePrevious'
import { useRouter } from 'next/router'

const exo = Exo({
  subsets: ['latin'],
})

const App: FC<AppProps> = ({ Component, ...rest }) => {
  const router = useRouter()
  const prevWindowLocationRef = usePrevious(router.pathname)

  useEffect(() => {
    if (prevWindowLocationRef === router.pathname) return
    pageView(window.location.pathname)
  }, [prevWindowLocationRef, router.pathname])

  const { store, props } = wrapper.useWrappedStore(rest)
  return (
    <Provider store={store}>
      <main className={exo.className}>
        <NextNProgress color="#F87C18" showOnShallow={false} />
        <Component {...props.pageProps} />
        <SnackbarManager />
        <SessionManager />
      </main>
    </Provider>
  )
}

export default appWithTranslation(App)